import { render } from "./AddSimCard.vue?vue&type=template&id=b6f2b1fa"
import script from "./AddSimCard.vue?vue&type=script&lang=js"
export * from "./AddSimCard.vue?vue&type=script&lang=js"
script.render = render

export default script